var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2849_12705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.515 17.91C3.24 17.145 0 13.455 0 9C0 4.05 4.05 0 9 0C13.95 0 18 4.05 18 9C18 13.455 14.76 17.145 10.485 17.91L9.99 17.505H8.01L7.515 17.91Z",
    fill: "url(#paint0_linear_2849_12705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5096 11.5198L12.9146 8.99977H10.5296V7.24477C10.5296 6.52477 10.7996 5.98477 11.8796 5.98477H13.0496V3.68977C12.4196 3.59977 11.6996 3.50977 11.0696 3.50977C8.99957 3.50977 7.55957 4.76977 7.55957 7.01977V8.99977H5.30957V11.5198H7.55957V17.8648C8.05457 17.9548 8.54957 17.9998 9.04457 17.9998C9.53957 17.9998 10.0346 17.9548 10.5296 17.8648V11.5198H12.5096Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2849_12705",
    x1: 9.00045,
    y1: 17.374,
    x2: 9.00045,
    y2: -0.0033155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2849_12705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6d608ae7d857f807d3d60126f50e6ee1.svg";
export { ForwardRef as ReactComponent };